'use client';
import { Box, Spinner } from '@chakra-ui/react';

const Layout = () => {
  return (
    <Box height="100vh" w="100%">
      <Spinner />
    </Box>
  );
};

export default Layout;
